import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class MFPurchaseOrderUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(data) {
        return await this.Repo.mfPurchaseOrder(data);
    }
}
export default MFPurchaseOrderUseCase;
